
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import * as _ref_QG1lc3NhZ2Vmb3JtYXQvY29yZQ_ from '@messageformat/core';
import * as _ref_YmNwLTQ3_ from 'bcp-47';
import { instantiate } from './tako-webApp-wasm-js.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_,
    '@messageformat/core': _ref_QG1lc3NhZ2Vmb3JtYXQvY29yZQ_,
    'bcp-47': _ref_YmNwLTQ3_
})).exports;

export const {
memory,
_initialize
} = exports


